// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2w4H_","inputDescription":"styles_inputDescription__b0XS5"};